// Caminho relativo: src/app/app.component.ts
import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { NetworkService } from './services/network.service';
import { AppVersion } from "@ionic-native/app-version/ngx";
import { UtilsService } from "./services/utils.service";
import { DataService } from './services/data.service';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  message: string;

  constructor(
    private storage: Storage,
    public networkService: NetworkService,
    private appVersion: AppVersion,
    private utilsService: UtilsService,
    private dataService: DataService
  ) {
    this.appVersion.getVersionNumber().then(appVersion => {
      if (!appVersion || appVersion.trim() === '') {
        appVersion = '1.8.1';
      }      
      window.localStorage.setItem('appVersion', appVersion);
    });
  }

  async ngOnInit() {
    await this.storage.create();
    await this.checkConnectivity();

    this.networkService.status$
    .pipe(distinctUntilChanged())
    .subscribe(async (isConnected: boolean) => {
  
      if (isConnected) {

  
        try {
          const loggedUserStr = await this.storage.get('logged-user');
  
          const loggedUser = typeof loggedUserStr === 'string'
            ? JSON.parse(loggedUserStr)
            : loggedUserStr;
           const userId = loggedUser?.user?.id;
  
          if (userId) {
            await this.dataService.syncContentWhenOnline(userId);
          }
  
          const visitsSyncResult = await this.dataService.sendCreatedVisitsWhenOnline();
  
          const serviceOrdersSyncResult = await this.dataService.sendCreatedServiceOrdersWhenOnline();
  
        } catch (error) {
          console.error('*** [DEBUG] Erro inesperado na sincronização offline:', error);
        }
      }
    });
  
  }

  async checkConnectivity() {
    await this.networkService.startNetworkListener();
    if (!this.networkService._isConnected) {
      console.log('conectionStatus', this.networkService._isConnected);
      this.utilsService.presentDefaultToast(
        'Apresentando funcionalidades limitadas em razão da falta de conexão com a internet.',
        'danger',
        'top',
        3000
      );
    }
  }
}
